import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import LoadingAnimation from "../../Components/Loading/LoadingAnimation";
import { TrashIcon } from "@heroicons/react/24/solid";
import { ToastContainer } from "react-toastify";
import { FaEdit } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import {
  GET_DOCUMENT_API,
  ADD_DOCUMENT_COMMENT_API,
  GET_DOCUMENT_COMMENTS_API,
  getApprovalsByDocumentId,
  UPDATE_DOCUMENT_API,
  deleteApproval,
  deleteComment,
  uploadSignature,
  StatusUpdate,createApproval
} from "../../Constants/apiRoutes";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FileViewer from "react-file-viewer";
import { HiArrowLeft, HiPencil } from "react-icons/hi";
import { FaFileWord, FaFilePdf } from "react-icons/fa";
import AddApprovalPopup from "./ApprovalPopup";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import { HiOutlineUpload, HiOutlineDownload } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";
import { BsArrowUpRightCircleFill } from "react-icons/bs";
import SignatureDialog from "./SignatureDialog";
import { useConfirmation } from "../../Components/ConfirmDialog";
import { useLocation } from "react-router-dom";
import { PERMISSIONS } from "../../Constants/permissions";
import api from "../../Components/ProtectedRoute/axiosInstance"; 
const ProjectStatus = [
  { id: 1, name: "Project Initiation" },
  { id: 2, name: "Project Planning" },
  { id: 3, name: "Project Execution" },
  { id: 4, name: "Project Control" },
  { id: 5, name: "Project Close" },
];

// const A4_WIDTH = 794;
const A4_WIDTH = 800;
const A4_HEIGHT = 990;

const DocumentsDetails = () => {
  const { documentId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [documentData, setDocumentData] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1.0);
  const [fileType, setFileType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showSignatureDialog, setShowSignatureDialog] = useState(false);
  const [signatures, setSignatures] = useState([]);
  const [isMarkingPosition, setIsMarkingPosition] = useState(false);
  const [markedPosition, setMarkedPosition] = useState(null);
  const documentContainerRef = useRef(null);
  const pdfContainerRef = useRef(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [markedPage, setMarkedPage] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyTexts, setReplyTexts] = useState("");
  const [originalPdfUrl, setOriginalPdfUrl] = useState(pdfUrl); // store separately
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [isSubmittingComment, setIsSubmittingComment] = useState(false);
  const [commentsData, setCommentsData] = useState([]);
  const [approvalData, setApprovalData] = useState([]);
  const { showConfirmation, ConfirmationDialog } = useConfirmation();
  const [isRedirected, setIsRedirected] = useState(false);
  const { userId } = useParams();
  const permissionsID = localStorage.getItem("PermissionIDs");
  const [canSign, setCanSign] = useState(false);
  const [isDocumentSigned, setIsDocumentSigned] = useState(false); // new state

  const [statuses] = useState([
    { id: 2, name: "Approved", color: "text-green-500" },
    { id: 1, name: "Pending", color: "text-yellow-500" },
    { id: 3, name: "Rejected", color: "text-red-500" },
    { id: 4, name: "Declined", color: "text-red-500" },
  ]);

  useEffect(() => {
    const redirectPath = sessionStorage.getItem("redirectAfterLogin");
    if (redirectPath) {
      sessionStorage.removeItem("redirectAfterLogin");
      setIsRedirected(true);
      navigate(redirectPath);
    }
  }, []);

  const getStatusStyles = (statusId) => {
    switch (statusId) {
      case 1:
        return {
          text: "text-yellow-600",
          dot: "bg-yellow-400",
        };
      case 2:
        return {
          text: "text-green-600",
          dot: "bg-green-500",
        };
      case 3:
        return {
          text: "text-red-600",
          dot: "bg-red-500",
        };
      case 4:
        return {
          text: "text-red-600",
          dot: "bg-red-500",
        };
      default:
        return {
          text: "text-gray-600",
          dot: "bg-gray-400",
        };
    }
  };

  const { text, dot } = getStatusStyles(documentData?.StatusId);

  const fetchDocumentData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const UserID = localStorage.getItem("UserID");
      const response = await api.get(
        `${GET_DOCUMENT_API}/${documentId}/${UserID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data?.data) {
        setDocumentData(response.data.data);
        if (response.data.data.Signatures) {
          setSignatures(JSON.parse(response.data.data.Signatures));
        }
      } else {
        toast.error("Document not found");
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      toast.error(error.response?.data?.message || "Failed to fetch document");
    } finally {
      setLoading(false);
    }
  };

  const fetchApprovals = async () => {
    try {
      const token = localStorage.getItem("token");
  
      const response = await api.get(
        `${getApprovalsByDocumentId}/${documentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data) {
        setApprovalData((prev) => ({
          ...prev,
          Approvals: response?.data,
        }));

        // Check if the current user has a required signature
        const hasRequiredSignature = response.data.some(
          (approval) =>
           Number(approval.UserID) === Number(userId) && approval.RequiresSignature === true
        );
        setCanSign(hasRequiredSignature);
       
      }
    } catch (error) {
      console.error("Error fetching approvals:", error);
      toast.error("Failed to fetch approvals");
    }
  };

  const fetchComments = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${GET_DOCUMENT_COMMENTS_API}/${documentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        setCommentsData((prev) => ({
          ...prev,
          Comments: response.data,
        }));
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
      toast.error("Failed to fetch comments");
    }
  };

  useEffect(() => {
    if (documentId) {
      fetchDocumentData();
      fetchApprovals();
      fetchComments();
    }
  }, [documentId]);

  useEffect(() => {
    if (documentData?.PublicUrl) {
      const ext = documentData.PublicUrl.split(".").pop()?.split("?")[0];
      if (ext) {
        const type = ext.toLowerCase();
        setFileType(type);
      }
    }
  }, [documentData?.PublicUrl]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleAddSignature = () => {
    if (fileType === "pdf" || fileType === "docx") {
      setIsMarkingPosition(true);
    } else {
      toast.error("Unsupported file format for digital signature");
    }
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleSaveSignature = async (signatureData) => {
    if (!markedPosition || markedPage === null) return;

    const UserID = Number(localStorage.getItem("UserID"));
    const tenantId = Number(localStorage.getItem("TenantID"));

    const adjustedPosition = {
      x: markedPosition.x,
      y: markedPosition.y,
    };

    const newSignature = {
      id: uuidv4(),
      type: signatureData.type,
      data: signatureData.data,
      position: adjustedPosition,
      pageIndex: markedPage,
      size: { width: 150, height: 30 },
    };

    try {
      // Convert base64 image to PNG Blob (works for all types now since text is converted to image)
      const base64Data = signatureData.data.split(",")[1];
      const binaryData = atob(base64Data);
      const byteArray = new Uint8Array(binaryData.length);
      for (let i = 0; i < binaryData.length; i++) {
        byteArray[i] = binaryData.charCodeAt(i);
      }
      const imageBlob = new Blob([byteArray], { type: "image/png" });

      // Prepare FormData
      const sigForm = new FormData();
      sigForm.append("file", imageBlob, "signature.png");
      sigForm.append("documentId", documentId);
      sigForm.append("tenantId", tenantId);
      sigForm.append("createdBy", UserID);
      sigForm.append("userId", UserID);
      sigForm.append("left", adjustedPosition.x.toString());
      sigForm.append("top", adjustedPosition.y.toString());
      sigForm.append("width", "150");
      sigForm.append("height", "30");

      // POST the signature image with metadata
      await axios.post(uploadSignature, sigForm, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      // Update Signature State
      setSignatures((prev) => {
        const updated = [
          ...prev.filter(
            (sig) =>
              !(
                sig.pageIndex === markedPage &&
                Math.abs(sig.position.x - adjustedPosition.x) < 5 &&
                Math.abs(sig.position.y - adjustedPosition.y) < 5
              )
          ),
          newSignature,
        ];
        setIsDocumentSigned(true);
        setDocumentData((prevData) => ({
          ...prevData,
          Signatures: JSON.stringify(updated),
        }));
        return updated;
      });

      // Modify the PDF visually
      const blob = await fetch(originalPdfUrl).then((res) => res.blob());
      const arrayBuffer = await blob.arrayBuffer();
      const pdfDoc = await PDFDocument.load(arrayBuffer);
      const page = pdfDoc.getPages()[markedPage - 1];

      const imageBytes = await fetch(signatureData.data).then((res) =>
        res.arrayBuffer()
      );
      const pngImage = await pdfDoc.embedPng(imageBytes);
      page.drawImage(pngImage, {
        x: (adjustedPosition.x / 100) * page.getWidth() - 75,
        y: (adjustedPosition.y / 100) * page.getHeight() - 15,
        width: 150,
        height: 30,
      });

      // Update preview
      const updatedPdfBytes = await pdfDoc.save();
      const updatedBlob = new Blob([updatedPdfBytes], {
        type: "application/pdf",
      });
      const updatedPdfUrl = URL.createObjectURL(updatedBlob);
      setPdfUrl(updatedPdfUrl);
      setOriginalPdfUrl(updatedPdfUrl);
    } catch (err) {
      console.error("Signature error:", err);
    }

    setIsDocumentSigned(true);
    setMarkedPosition(null);
    setMarkedPage(null);
    setShowSignatureDialog(false);
  };
  const clickTimerRef = useRef(null);

  const handleDocumentClick = (e, pageIndex) => {
    if (clickTimerRef.current) {
      clearTimeout(clickTimerRef.current);
      clickTimerRef.current = null;
      return; // Stop further execution if double-click cleared the timer
    }

    // Set the timer for single click
    const pageElement = e.currentTarget;

    clickTimerRef.current = setTimeout(() => {
      clickTimerRef.current = null;
    
      // Only handle position marking when not double-clicking
      if (isMarkingPosition && pageElement) {
        const rect = pageElement.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const clickY = e.clientY - rect.top;
        const x = (clickX / rect.width) * 100;
        const y = (clickY / rect.height) * 100;

        setMarkedPosition({ x, y });
        setMarkedPage(pageIndex);
        setIsMarkingPosition(true);
      }
    }, 250); // Delay for single click
  };

  const handleDownload = async () => {
    if (!documentData?.PublicUrl) {
      toast.error("No document file found");
      return;
    }

    setLoading(true);
    console.log("Starting document signing process");

    try {
      let pdfBytes;

      // Check if the file is a PDF or DOCX
      if (fileType === "pdf") {
        // Only do this if you are sure the URL is public and not signed
        const pdfUrl = documentData.PublicUrl.includes("?")
          ? `${documentData.PublicUrl}&t=${Date.now()}`
          : `${documentData.PublicUrl}?t=${Date.now()}`;

        console.log(`Fetching PDF from: ${pdfUrl}`);
        const pdfResponse = await fetch(pdfUrl, {
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
        });

        if (!pdfResponse.ok) {
          throw new Error(
            `Failed to fetch PDF (${pdfResponse.status}): ${pdfResponse.statusText}`
          );
        }

        pdfBytes = await pdfResponse.arrayBuffer();
      }  else {
        throw new Error("Unsupported file type");
      }

      const pdfDoc = await PDFDocument.load(pdfBytes, {
        ignoreEncryption: false,
        updateMetadata: false,
      });

      if (pdfDoc.isEncrypted) {
        throw new Error("PDF is encrypted/cannot be modified");
      }

      const pages = pdfDoc.getPages();
      if (pages.length === 0) {
        throw new Error("PDF contains no pages");
      }

      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

      if (isMarkingPosition && markedPosition && markedPage != null) {
        const pageIndex = markedPage - 1;
        if (pageIndex >= 0 && pageIndex < pages.length) {
          const page = pages[pageIndex];
          const { width, height } = page.getSize();

          const markerWidth = 150;
          const markerHeight = 50;
          const pdfX = (markedPosition.x / 100) * width;
          const pdfY = height - (markedPosition.y / 100) * height;

          const finalX = Math.max(
            0,
            Math.min(width - markerWidth, pdfX - markerWidth / 2)
          );
          const finalY = Math.max(
            0,
            Math.min(height - markerHeight, pdfY - markerHeight / 2)
          );

          // Tailwind's border-blue-500 and 30% opacity blue background
          const borderBlue400 = rgb(96 / 255, 165 / 255, 250 / 255);
          page.drawRectangle({
            x: finalX,
            y: finalY,
            width: markerWidth,
            height: markerHeight,
            borderWidth: 1,
            borderColor: borderBlue400,
          });

          const hasSignature = signatures.some(
            (sig) =>
              sig.pageIndex === markedPage &&
              sig.position.x === markedPosition.x &&
              sig.position.y === markedPosition.y
          );

          if (!hasSignature) {
            const textBlue500 = rgb(59 / 255, 130 / 255, 246 / 255); // #3B82F6

            page.drawText("Signature", {
              x: finalX + markerWidth / 2 - 30,
              y: finalY + markerHeight / 12,
              size: 12,
              font,
              color: textBlue500,
            });
          }
        }
      }

      // Group signatures by page
      const signaturesByPage = {};
      signatures.forEach((sig) => {
        const idx = (sig.pageIndex ?? 1) - 1;
        if (!signaturesByPage[idx]) signaturesByPage[idx] = [];
        signaturesByPage[idx].push(sig);
      });

      const results = [];

      for (const [pageIndexStr, pageSignatures] of Object.entries(
        signaturesByPage
      )) {
        const pageIndex = parseInt(pageIndexStr);
        if (pageIndex < 0 || pageIndex >= pages.length) continue;

        const page = pages[pageIndex];
        const { width, height } = page.getSize();

        const pageResults = await Promise.all(
          pageSignatures.map(async (sig) => {
            try {
              const { type, data, position, style, size } = sig;

              if (type === "draw" || type === "image") {
                let imageData;

                if (type === "draw") {
                  if (!data || !data.includes("base64")) {
                    throw new Error("Invalid draw signature format");
                  }
                  const base64 = data.split(",")[1];
                  imageData = Uint8Array.from(atob(base64), (c) =>
                    c.charCodeAt(0)
                  );
                } else {
                  const imgRes = await fetch(data);
                  if (!imgRes.ok) throw new Error("Failed to fetch image");
                  imageData = await imgRes.arrayBuffer();
                }

                let image;
                try {
                  image = await pdfDoc.embedPng(imageData);
                } catch {
                  image = await pdfDoc.embedJpg(imageData);
                }

                const imgWidth = (size?.width ?? 150) * 0.4;
                const imgHeight = (size?.height ?? 75) * 0.8;
                const x = (position.x / 100) * width - imgWidth / 2;
               
                 const y =
                  height - (position.y / 100) * height - imgHeight / 4 + 5;

                page.drawImage(image, {
                  x,
                  y,
                  width: imgWidth,
                  height: imgHeight,
                });

                return { ...sig, status: "added" };
              } else if (type === "text") {
                const fontSize = style?.fontSize || 16;
                const textWidth = font.widthOfTextAtSize(data, fontSize);
                const textHeight = fontSize;

                const x = (position.x / 100) * width - textWidth / 4 - 10;
                const y =
                  height - (position.y / 100) * height - textHeight / 4 + 10;

                page.drawText(data, {
                  x,
                  y,
                  size: fontSize,
                  font,
                  color: rgb(0, 0, 0),
                });

                return { ...sig, status: "added" };
              }
            } catch (err) {
              return { ...sig, status: "failed", error: err.message };
            }
          })
        );

        results.push(...pageResults);
      }

      const modifiedBytes = await pdfDoc.save();
      const blob = new Blob([modifiedBytes], { type: "application/pdf" });
      const filename =
        documentData.DocumentName?.replace(/\.pdf$/, "") + "_signed.pdf";

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename || "signed-document.pdf";
      link.click();
    } catch (err) {
      console.error("Download error:", err);
      toast.error(`Error: ${err.message}`);
    } finally {
      setLoading(false);
      toast.dismiss();
      console.log("Signing process done");
    }
  };

  const handleUpdateDocument = async () => {
    setIsLoading(true);

    const UserID = Number(localStorage.getItem("UserID"));
    const tenantId = Number(localStorage.getItem("TenantID"));

    if (!documentData || !documentData.DocumentNo) {
      toast.error("Invalid document data.");
      setIsLoading(false);
      return;
    }

    try {
      const pdfUrl = documentData.PublicUrl.includes("?")
        ? `${documentData.PublicUrl}&t=${Date.now()}`
        : `${documentData.PublicUrl}?t=${Date.now()}`;

      const pdfResponse = await fetch(pdfUrl, {
        mode: "cors",
        cache: "no-cache",
        // credentials: "same-origin",
      });

      if (!pdfResponse.ok) {
        throw new Error(
          `Failed to fetch PDF (${pdfResponse.status}): ${pdfResponse.statusText}`
        );
      }

      const pdfBytes = await pdfResponse.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes, {
        ignoreEncryption: false,
        updateMetadata: false,
      });

      if (pdfDoc.isEncrypted) {
        throw new Error("PDF is encrypted/cannot be modified");
      }

      const pages = pdfDoc.getPages();
      if (pages.length === 0) throw new Error("PDF contains no pages");

      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

      if (isMarkingPosition && markedPosition && markedPage != null) {
        const pageIndex = markedPage - 1;
        if (pageIndex >= 0 && pageIndex < pages.length) {
          const page = pages[pageIndex];
          const { width, height } = page.getSize();

          const markerWidth = 150;
          const markerHeight = 50;
          const pdfX = (markedPosition.x / 100) * width;
          const pdfY = height - (markedPosition.y / 100) * height;

          const finalX = Math.max(
            0,
            Math.min(width - markerWidth, pdfX - markerWidth / 2)
          );
          const finalY = Math.max(
            0,
            Math.min(height - markerHeight, pdfY - markerHeight / 30)
          );

          const borderBlue400 = rgb(96 / 255, 165 / 255, 250 / 255);

          page.drawRectangle({
            x: finalX,
            y: finalY,
            width: markerWidth,
            height: markerHeight,
            borderWidth: 1,
            borderColor: borderBlue400,
          });

          const hasSignature = signatures.some(
            (sig) =>
              sig.pageIndex === markedPage &&
              sig.position.x === markedPosition.x &&
              sig.position.y === markedPosition.y
          );

          if (!hasSignature) {
            const textBlue500 = rgb(59 / 255, 130 / 255, 246 / 255);
            page.drawText("Signature", {
              x: finalX + markerWidth / 2 - 30,
              y: finalY + markerHeight / 12,
              size: 12,
              font,
              color: textBlue500,
            });
          }
        }
      }

      const signaturesByPage = {};
      signatures.forEach((sig) => {
        const idx = (sig.pageIndex ?? 1) - 1;
        if (!signaturesByPage[idx]) signaturesByPage[idx] = [];
        signaturesByPage[idx].push(sig);
      });

      for (const [pageIndexStr, pageSignatures] of Object.entries(
        signaturesByPage
      )) {
        const pageIndex = parseInt(pageIndexStr);
        if (pageIndex < 0 || pageIndex >= pages.length) continue;

        const page = pages[pageIndex];
        const { width, height } = page.getSize();

        await Promise.all(
          pageSignatures.map(async (sig) => {
            try {
              const { type, data, position, style } = sig;

              if (type === "draw" || type === "image") {
                let imageData;

                if (type === "draw") {
                  if (!data || !data.includes("base64"))
                    throw new Error("Invalid data format");
                  const base64 = data.split(",")[1];
                  imageData = Uint8Array.from(atob(base64), (c) =>
                    c.charCodeAt(0)
                  );
                } else {
                  const imgRes = await fetch(data);
                  if (!imgRes.ok) throw new Error("Failed to fetch image");
                  imageData = await imgRes.arrayBuffer();
                }

                let image;
                try {
                  image = await pdfDoc.embedPng(imageData);
                } catch {
                  image = await pdfDoc.embedJpg(imageData);
                }

                const scale = 0.25; // increased from 0.2
                const maxWidth = 150; // matching the UI
                const maxHeight = 30;

                let imgWidth = image.width;
                let imgHeight = image.height;

                if (imgWidth > maxWidth) {
                  const r = maxWidth / imgWidth;
                  imgWidth = maxWidth;
                  imgHeight *= r;
                }

                if (imgHeight > maxHeight) {
                  const r = maxHeight / imgHeight;
                  imgHeight = maxHeight;
                  imgWidth *= r;
                }

                const x = Math.max(
                  0,
                  Math.min(width - imgWidth, (position.x / 100) * width - 40)
                );
               
const y = Math.max(
  0,
  Math.min(
    height - imgHeight,
    height - (position.y / 100) * height - imgHeight / 2-5
  )
);

                page.drawImage(image, {
                  x,
                  y,
                  width: imgWidth,
                  height: imgHeight,
                });
              } else if (type === "text") {
                const fontSize = style?.fontSize || 10;
                const x = (position.x / 100) * width;
                const y = height - (position.y / 100) * height;
                page.drawText(data, {
                  x: x - 30,
                  y: y + 15,
                  size: fontSize,
                  font,
                  color: rgb(0, 0, 0),
                });
              }
            } catch (err) {
              console.error("Signature error:", err.message);
            }
          })
        );
      }

      const modifiedPdfBytes = await pdfDoc.save();

      const formData = new FormData();
      // formData.append("DocumentNo", documentData.DocumentNo);
      formData.append("DepartmentId", documentData.DepartmentId || "");
      formData.append("DocumentName", documentData.DocumentName || "");
      formData.append("CustomerName", documentData.CustomerName || "");
      formData.append("ProjectPhaseId", documentData.ProjectPhaseId || "");
      formData.append("StatusId", Number(documentData.StatusId) || 0);
      formData.append("UserID", UserID || "");
      formData.append(
        "ProjectTypeId",
        Number(documentData.ProjectTypeName) || 1
      );
      formData.append("UpdatedBy", UserID || 0);
      if (tenantId) formData.append("TenantId", tenantId);
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      formData.append("UploadDocument", blob, "modified-document.pdf");

      const response = await axios.put(
        `${UPDATE_DOCUMENT_API}/${documentId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === "success") {
        toast.success("Document updated successfully!");
        setIsMarkingPosition(false);
        setSignatures([]);
        setIsDocumentSigned(true);
        setDocumentData((prevData) => ({
          ...prevData,
          Signatures: JSON.stringify([]),
        }));
        setTimeout(() => {
          fetchDocumentData();
        }, 1000);
      } else {
        toast.error(response.data.message || "Failed to update document");
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error(`Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleClick = (e) => {
      const span = e.target;
      const pageDiv = span.closest(".react-pdf__Page");
      if (!pageDiv) return;

      const pageRect = pageDiv.getBoundingClientRect();
      const spanRect = span.getBoundingClientRect();

      // Calculate center of span relative to page
      const centerX = spanRect.left + spanRect.width / 2;
      const centerY = spanRect.top + spanRect.height / 2;

      const xPercent = ((centerX - pageRect.left) / pageRect.width) * 100;
      const yPercent = ((centerY - pageRect.top) / pageRect.height) * 100;

      // Extract page index from data-page-number (PDF rendering adds this)
      const pageIndex = parseInt(pageDiv.getAttribute("data-page-number"));

      setMarkedPosition({ x: xPercent, y: yPercent });
      setMarkedPage(pageIndex);
      setShowSignatureDialog(true);
    };

    const checkTextLayer = () => {
      const layers = document.querySelectorAll(".textLayer");
      layers.forEach((layer) => {
        const spans = layer.querySelectorAll("span");
        spans.forEach((span) => {
          if (span.textContent.includes("Signature")) {
            console.log("Text found in PDF!");
            span.style.cursor = "pointer";
            span.onclick = handleClick;
          }
        });
      });
    };

    const timeoutId = setTimeout(checkTextLayer, 1000);

    return () => {
      clearTimeout(timeoutId);
      const spans = document.querySelectorAll(".textLayer span");
      spans.forEach((span) => {
        if (span.onclick) {
          span.onclick = null;
        }
      });
    };
  }, [numPages, setShowSignatureDialog, fetchDocumentData]);

  const handleReplySubmit = async (commentID) => {
    const reply = replyTexts[commentID];
    if (!reply?.trim()) {
      toast.error("Please enter a reply");
      return;
    }

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("UserID");
    const tenantId = localStorage.getItem("TenantID");

    try {
      const response = await axios.post(
        ADD_DOCUMENT_COMMENT_API,
        {
          DocumentID: documentId,
          UserID: userId,
          CommentText: reply,
          TenantId: tenantId,
          ParentCommentID: commentID,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("Reply added successfully");
        setReplyTexts((prev) => ({ ...prev, [commentID]: "" }));
        setReplyingTo(null);
        setTimeout(() => {
          fetchComments();
        }, 1000); // 1 second is usually enough
      } else {
        toast.error(response.data.message || "Failed to add reply");
      }
    } catch (error) {
      console.error("Failed to add sub-comment", error);
      toast.error("Failed to add reply");
    }
  };

  const handleDeleteApproval = (UserID) => {
    showConfirmation(
      "Delete Approval",
      "Are you sure you want to remove this approval?",
      async () => {
        try {
          const token = localStorage.getItem("token");
          const response = await fetch(
            `${deleteApproval}/${documentId}/${UserID}`,
            {
              method: "DELETE",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          fetchApprovals();

          if (!response.ok) {
            throw new Error("Failed to delete approval");
          }

          // Update UI
          setDocumentData((prev) => ({
            ...prev,
            Approvals: prev.Approvals.filter((a) => a.UserID !== UserID),
          }));
        } catch (error) {
          console.error("Error deleting approval:", error);
          throw error; // This will trigger the error toast in the confirmation dialog
        }
      }
    );
  };

  const handleDeleteComment = async (commentId) => {
    showConfirmation(
      "Delete Comment",
      "Are you sure you want to delete this comment?",
      async () => {
        console.log("Trying to delete comment ID:", commentId);
        const token = localStorage.getItem("token");
        const res = await fetch(`${deleteComment}/${commentId}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const result = await res.json();

        fetchComments();

        if (!res.ok) {
          throw new Error(result.message || "Failed to delete comment");
        }

        setDocumentData((prevData) => ({
          ...prevData,
          Comments: prevData.Comments.filter(
            (comment) => comment.CommentID !== commentId
          ),
        }));
      }
    );
  };

  const handleDeleteReply = async (replyId) => {
    showConfirmation(
      "Delete Reply",
      "Are you sure you want to delete this reply?",
      async () => {
        const token = localStorage.getItem("token");
        const res = await fetch(`${deleteComment}/${replyId}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          throw new Error("Failed to delete reply");
        }

        setDocumentData((prevData) => ({
          ...prevData,
          Comments: prevData.Comments.filter(
            (comment) => comment.CommentID !== replyId
          ),
        }));
        fetchComments();
      }
    );
  };
  const handleAddComment = () => {
    setShowCommentModal(true);
  };
  const handleSubmitComment = async () => {
    if (!commentText.trim()) {
      toast.error("Please enter a comment");
      return;
    }

    setIsSubmittingComment(true);
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("UserID");
    const tenantId = localStorage.getItem("TenantID");

    try {
      const response = await axios.post(
        ADD_DOCUMENT_COMMENT_API,
        {
          DocumentID: documentId,
          UserID: userId,
          CommentText: commentText,
          TenantId: tenantId,
          ParentCommentID: 0,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("Comment added successfully");
        setCommentText("");
        setShowCommentModal(false);
        setTimeout(() => {
          fetchComments();
        }, 1000); // 1 second is usually enough
      } else {
        toast.error(response.data.message || "Failed to add comment");
      }
    } catch (error) {
      console.error("Error adding comment:", error);
      toast.error("Failed to add comment");
    } finally {
      setIsSubmittingComment(false);
    }
  };

  const handleStatusUpdate = (status) => {
    const UserID = localStorage.getItem("UserID");

    // Only show missing signature warning if approving (not declining)
    if (status === "approved" && !isDocumentSigned && canSign) {
      showConfirmation(
        "Missing Signature",
        "Please add a signature on the document before approving.",
        () => {}, // No-op
        true // suppressToast = true
      );
      return;
    }

    // Proceed with confirmation based on status
    showConfirmation(
      `Confirm ${status}`,
      `Are you sure you want to ${status} this document?`,
      async () => {
        // Async callback to handle the update process
        try {
          setIsLoading(true);

          // Only call handleUpdateDocument if approving and signed
          if (status === "approved" && isDocumentSigned) {
            await handleUpdateDocument();
          }

          const tenantId = localStorage.getItem("TenantID");
          const payload = {
            Status: status,
            TenantId: Number(tenantId),
            Reinitiate:false, 
          };

          // Update the document status
          await axios.put(
            `${StatusUpdate}/${documentId}/user/${UserID}`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );

          // After a successful update, navigate with a delay
          setTimeout(() => {
            setIsLoading(false);
            navigate("/department", {
              state: {
                message: `Document has been ${status} successfully!`,
                status: status,
              },
            });
          }, 2000);
        } catch (error) {
          console.error(`Error updating status to "${status}":`, error);
         const errorMessage =
    error?.response?.data?.error || 
    error?.message ||               
    `Failed to ${status} document`; 
  toast.error(errorMessage);
          setIsLoading(false);
        }
      },
      true 
    );
  };

  useEffect(() => {
    // when documentId or documentData changes
    setIsDocumentSigned(false);
  }, [documentId, documentData]);

  const handleEdit = (documentId) => {
    const params = new URLSearchParams(location.search);
    const filterName = params.get("filter");

    navigate(`/add-document/${documentId}?filter=${filterName}`, {
      state: { from: location.pathname + location.search },
    });
  };

  const handleDrop = (e, pageIndex) => {
    e.preventDefault();

    const container = documentContainerRef.current;
    if (!container) return;

    const rect = container.getBoundingClientRect();
    const dropX = e.clientX - rect.left;
    const dropY = e.clientY - rect.top;

    const xPercent = (dropX / rect.width) * 100;
    const yPercent = (dropY / rect.height) * 100;

    const type = e.dataTransfer.getData("signatureType");
    const src = e.dataTransfer.getData("signatureSrc");

    if (type === "image" && src) {
      const newSignature = {
        id: Date.now(), // unique ID
        type: "image",
        data: src,
        pageIndex,
        position: {
          x: xPercent,
          y: yPercent,
        },
      };

      setSignatures((prev) => [...prev, newSignature]);
    }
  };

const handleReInitiate = async (approval) => {
  showConfirmation(
    "Confirm Re-initiation",
    "Are you sure you want to re-initiate this approval?",
    async () => {
      const token = localStorage.getItem("token");
       const UserID = localStorage.getItem("UserID");
      const tenantId = localStorage.getItem("TenantID");
const payload = {
   Status: "pending",
  TenantId: Number(tenantId),
  Reinitiate:true, 
   reqUserId: approval.UserID,
};
      try {
        setLoading(true);
      
        const response = await axios.put(
          `${StatusUpdate}/${documentId}/user/${approval.UserID}`
          , payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
     fetchApprovals();
     fetchDocumentData();
      } catch (error) {
        console.error("Error in re-initiate mail:", error);

        const errorMessage =
          error?.response?.data?.details ||
          error?.message ||
          "Failed to re-initiate approval.";

        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    },
     true
  );
};

  const renderDocumentPreview = () => {
    if (!documentData?.PublicUrl) return null;

    const handleApplySignature = () => {
      if (markedPosition && markedPage) {
        setShowSignatureDialog(true);
      }
    };

    return (
      <div
        className="relative bg-gray-100"
        ref={documentContainerRef}
        style={{ cursor: isMarkingPosition ? "crosshair" : "default" }}
      >
        <div className="document-container">
          {fileType === "pdf" ? (
            <Document
              file={documentData.PublicUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              loading={<LoadingAnimation />}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <div
                  key={`page_${index + 1}`}
                  className="relative mx-auto mb-10 shadow-xl bg-white border border-gray-300"
                  style={{
                    width: `${A4_WIDTH * scale}px`,
                    cursor: isMarkingPosition ? "crosshair" : "default",
                    position: "relative",
                  }}
                  onClick={(e) => handleDocumentClick(e, index + 1)}
                >
                  <Page
                    pageNumber={index + 1}
                    scale={scale}
                    width={A4_WIDTH * scale}
                    className="w-full h-full"
                  />

                  {isMarkingPosition &&
                    markedPosition &&
                    markedPage === index + 1 &&
                    !signatures.some((sig) => sig.pageIndex === markedPage) && (
                      <div
                        className="absolute border-4 border-black bg-opacity-30 w-[200px] h-[70px] rounded-xl"
                        style={{
                          left: `${markedPosition.x}%`,
                          top: `${markedPosition.y}%`,
                          transform: "translate(-50%, -50%)",
                          pointerEvents: "auto",
                        }}
                      >
                        <div className="text-center text-black mt-10 font-sans">
                          Signature Placeholder
                        </div>
                      </div>
                    )}

                  {signatures
                    .filter((signature) => signature.pageIndex === index + 1)
                    .map((signature) => (
                      <div
                        key={signature.id}
                        className="absolute group"
                        style={{
                          left: `${signature.position.x}%`,
                          top: `${signature.position.y + 1}%`,
                          transform: `translate(-50%, -50%)`,
                        }}
                      >
                        {signature.type === "draw" ||
                        signature.type === "image" ? (
                          <img
                            src={signature.data}
                            alt="signature"
                            className="max-w-[200px] max-h-[35px]"
                            style={{ transform: `scale(${scale})` }}
                          />
                        ) : (
                          <div
                            className="text-signature"
                            style={{
                              fontFamily:
                                signature.style?.fontFamily || "cursive",
                              fontSize: `${signature.style?.fontSize || 20}px`,
                              color: signature.style?.color || "#000000",
                              transform: `scale(${scale})`,
                            }}
                          >
                            {signature.data}
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              ))}
            </Document>
          ) : (
            <div
              className="relative"
              ref={documentContainerRef}
              onClick={(e) => handleDocumentClick(e, 1)} // Hardcoded pageIndex for DOCX
              style={{ cursor: isMarkingPosition ? "crosshair" : "default" }}
            >
              <FileViewer
                fileType={fileType}
                filePath={documentData.PublicUrl}
              />

              {isMarkingPosition && markedPosition && markedPage === 1 && (
                <div
                  className="absolute border-2 border-blue-400 bg-opacity-30 w-[200px] h-[70px]"
                  style={{
                    left: `${markedPosition.x}%`,
                    top: `${markedPosition.y}%`,
                    transform: "translate(-50%, -50%)",
                    pointerEvents: "auto",
                  }}
                >
                  <div className="text-center text-blue-500 mt-10 font-sans">
                    Signature
                  </div>
                </div>
              )}

              {signatures
                .filter((signature) => signature.pageIndex === 1)
                .map((signature) => (
                  <div
                    key={signature.id}
                    className="absolute group"
                    style={{
                      left: `${signature.position.x}%`,
                      top: `${signature.position.y}%`,
                      transform: `translate(-50%, -50%)`,
                    }}
                  >
                    {signature.type === "draw" || signature.type === "image" ? (
                      <img
                        src={signature.data}
                        alt="signature"
                        className="max-w-[200px] max-h-[100px]"
                        style={{ transform: `scale(${scale})` }}
                      />
                    ) : (
                      <div
                        className="text-signature"
                        style={{
                          fontFamily: signature.style?.fontFamily || "cursive",
                          fontSize: `${signature.style?.fontSize || 20}px`,
                          color: signature.style?.color || "#000000",
                          transform: `scale(${scale})`,
                        }}
                      >
                        {signature.data}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          )}
        </div>

        {isMarkingPosition && (
          <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-white px-4 py-2 rounded-lg shadow-lg z-50">
            Click where you want to place the signature
          </div>
        )}

        {/* Add Apply Signature button when a position is marked */}
        {isMarkingPosition && markedPosition && (
          <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-white px-4 py-2 rounded-lg shadow-lg z-50">
            <button
              className="bg-[#8B4513] text-white px-4 py-2 rounded"
              onClick={handleApplySignature}
            >
              Select Signature
            </button>
          </div>
        )}
      </div>
    );
  };

 

  return (
    <div className="flex h-screen bg-white mt-10">
      <ToastContainer />
      <ConfirmationDialog />
        {loading && <LoadingAnimation />}
      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Top Bar */}
        <div className="border-b p-4 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <button
              onClick={handleGoBack}
              className="p-2 hover:bg-gray-100 rounded"
            >
              <HiArrowLeft className="w-5 h-5" />
            </button>
            <h1 className="text-lg font-medium flex items-center">
              {fileType === "pdf" ? (
                <FaFilePdf className="w-5 h-5 text-red-500 mr-2" />
              ) : fileType === "docx" ? (
                <FaFileWord className="w-5 h-5 text-blue-600 mr-2" />
              ) : null}
              {documentData?.DocumentName || "Document Details"}
            </h1>
            <span className="text-gray-500 text-sm">
              Document No: {documentData?.DocumentNo}
            </span>
          </div>
          <div className="flex items-center space-x-4">
            {(fileType === "pdf" || fileType === "docx") && (
              <div className="mb-4">
                <button
                  onClick={handleAddSignature}
                  disabled={userId ? !canSign : false} // Disable only if userId exists and can't sign
                  className={`px-4 py-2 rounded flex items-center text-white bg-[#8B4513] 
        ${
          userId && !canSign
            ? "opacity-50 cursor-not-allowed"
            : "hover:bg-opacity-90"
        }`}
                >
                  <HiPencil className="w-4 h-4 mr-2" />
                  Add Signature
                </button>
              </div>
            )}

            <div className="flex items-center space-x-2">
              <div className="flex items-center space-x-1">
                {/* Dot */}
                <span className={`w-2 h-2 rounded-full ${dot}`}></span>

                {/* Status Text */}
                <p className={`text-sm font-medium ${text}`}>
                  {documentData?.StatusId === 1
                    ? "Pending"
                    : documentData?.StatusId === 2
                    ? "Approved"
                    : documentData?.StatusId === 3
                    ? "Rejected"
                    : documentData?.StatusId === 4
                    ? "Declined"
                    : "Unknown"}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Document Content */}
        <div className="flex-1 p-8 overflow-hidden">
          <div className="h-full flex flex-col">
            {/* Document Details */}
            <div className="mb-4 bg-white rounded-lg shadow-sm p-4">
              <div className="relative">
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  <div>
                    <p className="text-sm text-gray-500">Document No</p>
                    <p className="font-medium">{documentData?.DocumentNo}</p>
                  </div>

                  <div>
                    <p className="text-sm text-gray-500">Customer Name</p>
                    <p className="font-medium">{documentData?.CustomerName}</p>
                  </div>

                  <div>
                    <p className="text-sm text-gray-500">Project Type</p>
                    <p className="font-medium">
                      {documentData?.ProjectTypeName}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Project Type Status</p>
                    <p className="font-medium">
                      {ProjectStatus.find(
                        (status) => status.id === documentData?.ProjectPhaseId
                      )?.name || "N/A"}
                    </p>
                  </div>
                </div>

                {/* Edit button positioned absolutely in top-right */}
                <div className="absolute  -top-10 right-0">
                  <button
                    onClick={() => handleEdit(documentData?.DocumentID)}
                    className="px-4 py-2 bg-[#8B4513] text-white rounded transition-colors duration-300"
                    title="Edit"
                  >
                    <FaEdit className="w-5 h-5 sm:w-4 sm:h-4" />
                  </button>
                </div>
              </div>
              <div className="flex justify-between mt-4 items-center">
                {/* Updated Date on the left */}
                <div>
                  <p className="text-sm text-gray-500">Updated Date</p>
                  <p className="font-medium">
                    {new Date(
                      documentData?.UpdatedDate || documentData?.CreatedDate
                    ).toLocaleString("en-US", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </p>
                </div>

                {/* Buttons on the right */}
                <div className="flex space-x-4 items-center">
                  <button
                    onClick={handleDownload}
                    className="px-4 py-2 bg-[#8B4513] text-white rounded hover:bg-opacity-90 flex items-center"
                    title="Download Document"
                  >
                    <HiOutlineDownload className="w-5 h-5" />
                  </button>

                  <button
                    onClick={handleUpdateDocument}
                    disabled={userId ? !canSign : false}
                    className={`px-4 py-2 rounded flex items-center text-white bg-[#8B4513] ${
                      userId && !canSign
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-opacity-90"
                    }`}
                    title="Update Document"
                  >
                    {isLoading ? (
                      <svg
                        className="animate-spin h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    ) : (
                      <HiOutlineUpload className="w-5 h-5 text-white" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Document Preview */}
            <div
              className="flex-1 bg-gray-100 rounded-lg shadow-sm overflow-auto relative"
              ref={pdfContainerRef}
            >
              {renderDocumentPreview()}
            </div>
          </div>
        </div>
      </div>
      {/* Right Sidebar - Approvals */}
      <div className="w-80 border-l bg-gray-50">
        <div className="p-4">
          <div className="flex items-center justify-between mt-6">
            <h2 className="font-semibold mb-4 text-gray-800">
              Approval History
            </h2>

            {!userId && (
              <button
                onClick={() => setIsPopupOpen(true)}
                className="px-4 py-2 bg-[#8B4513] text-white rounded hover:bg-opacity-90 flex items-center"
              >
                <FaPlus className="w-4 h-4" />
              </button>
            )}
          </div>

          {userId ? (
            // If userId exists → Show Approve/Decline only
            <div className="flex flex-col sm:flex-row gap-2 sm:space-x-4 w-full">
              <button
                className="bg-green-500 text-white px-6 sm:px-10 py-2 rounded hover:bg-green-600 w-full sm:w-auto"
                onClick={() => handleStatusUpdate("approved")}
              >
                Approve
              </button>
              <button
                className="bg-red-500 text-white px-6 sm:px-10 py-2 rounded hover:bg-red-600 w-full sm:w-auto"
                onClick={() => handleStatusUpdate("declined")}
              >
                Decline
              </button>
            </div>
          ) : (
            // Otherwise show approval history
            <div className="max-h-[250px] overflow-y-auto space-y-4 pr-2">
              {approvalData?.Approvals?.map((approval, index) => {
                const status = statuses.find(
                  (s) => s.id === approval?.ApprovalLevel
                ); // 👉 Move const here

                return (
                  <div
                    key={index}
                    className="bg-white p-3 rounded-lg shadow-sm relative"
                  >
                    <button
                      className="absolute top-2 right-2 text-[#8B4513] hover:text-red-500"
                      onClick={() => handleDeleteApproval(approval?.UserID)}
                    >
                      <TrashIcon className="w-4 h-4" />
                    </button>

                    <div className="flex items-center space-x-2">
                       <span
    className={`w-2 h-2 rounded-full ${
      approval?.ApprovalLevel === 1
        ? "bg-yellow-500"
        : approval?.ApprovalLevel === 2
        ? "bg-green-500"
        : approval?.ApprovalLevel === 3
        ? "bg-red-500"
        : approval?.ApprovalLevel === 4
        ? "bg-red-500"
        : "bg-gray-300"
    }`}
  ></span>
                      <span className="font-medium text-gray-800">
                        {approval.UserName}
                      </span>

                      <span
                        className={`text-sm ${
                          status?.color || "text-yellow-500"
                        }`}
                      >
                        {status?.name || "Pending"}
                      </span>
                    </div>

                    {approval.Comments && (
                      <p className="text-sm text-gray-600 mt-2">
                        {approval.Comments}
                      </p>
                    )}
 <div className="flex items-center space-x-1">
                  <div className="text-xs text-gray-400 mt-2">
                      <p>Level: {approval.ApprovalLevel}</p>
                      <p>
                        Date:{" "}
                        {approval?.CreatedDate
                          ? new Date(approval.CreatedDate).toLocaleString()
                          : "N/A"}
                      </p>
                    </div>
                       {status?.name === "Declined" && (
        <div className="mt-2">
  <button
    onClick={() => handleReInitiate(approval)}
    className="text-xs px-3 py-1 bg-[#8B4513] text-white rounded"
  >
    Re-Initiate
  </button>
</div>

        )}
                  </div>
                    </div>
                );
              })}
            </div>
          )}
        </div>
        {permissionsID.includes(PERMISSIONS.VIEW_DOCUMENT_COMMENTS) && (
          <div className="p-4">
            <div className="flex items-center justify-between mt-6 mb-4">
              <h2 className="text-xl font-semibold text-gray-800">Comments</h2>
              <button
                onClick={handleAddComment}
                className="px-4 py-2 bg-[#8B4513] text-white rounded hover:bg-opacity-90 flex items-center"
              >
                <FaPlus className="w-4 h-4" />
              </button>
            </div>

            <div className="max-h-[300px] overflow-y-auto pr-2 space-y-5">
              {commentsData.Comments?.length > 0 ? (
                commentsData.Comments.filter(
                  (comment) => comment.ParentCommentID === null
                ).map((parentComment) => {
                  const replies = commentsData.Comments.filter(
                    (reply) => reply.ParentCommentID === parentComment.CommentID
                  );

                  return (
                    <div
                      key={parentComment.CommentID}
                      className="bg-white p-4 rounded-lg shadow-sm border"
                    >
                      {/* Parent comment */}
                      <div className="flex justify-between items-start mb-1">
                        <div>
                          <p className="text-base font-medium text-gray-800">
                            {parentComment.UserName || "Unknown User"}
                          </p>
                          <p className="text-xs text-gray-500">
                            {new Date(
                              parentComment.CreatedDate
                            ).toLocaleString()}
                          </p>
                        </div>
                        <div className="flex items-center space-x-3">
                          <button
                            onClick={() =>
                              setReplyingTo(
                                replyingTo === parentComment.CommentID
                                  ? null
                                  : parentComment.CommentID
                              )
                            }
                            className="text-blue-600 text-sm hover:underline"
                          >
                            Reply
                          </button>
                          <button
                            onClick={() =>
                              handleDeleteComment(parentComment.CommentID)
                            }
                            className="text-[#8B4513] hover:text-red-500"
                          >
                            <TrashIcon className="w-4 h-4" />
                          </button>
                        </div>
                      </div>

                      <p className="text-sm text-gray-700 mt-2">
                        {parentComment.CommentText}
                      </p>

                      {/* Reply input */}
                      {replyingTo === parentComment.CommentID && (
                        <div className="mt-3 relative max-w-md">
                          <input
                            type="text"
                            value={replyTexts[parentComment.CommentID] || ""}
                            onChange={(e) =>
                              setReplyTexts({
                                ...replyTexts,
                                [parentComment.CommentID]: e.target.value,
                              })
                            }
                            placeholder="Write a reply..."
                            className="w-full pr-10 px-3 py-2 border rounded text-sm"
                          />
                          <button
                            onClick={() =>
                              handleReplySubmit(parentComment.CommentID)
                            }
                            className="absolute right-2 top-1/2 -translate-y-1/2 text-[#8B4513] hover:text-[#A0522D]"
                          >
                            <BsArrowUpRightCircleFill size={20} />
                          </button>
                        </div>
                      )}

                      {/* Replies */}
                      {replies.length > 0 && (
                        <div className="mt-4 space-y-3 pl-4 border-l-2 border-gray-200">
                          {replies.map((reply) => (
                            <div
                              key={reply.CommentID}
                              className="bg-gray-100 p-3 rounded-lg shadow-sm"
                            >
                              <div className="flex justify-between items-start mb-1">
                                <div>
                                  <p className="text-sm font-medium text-gray-700">
                                    {reply.UserName || "Unknown User"}
                                  </p>
                                  <p className="text-xs text-gray-500">
                                    {new Date(
                                      reply.CreatedDate
                                    ).toLocaleString()}
                                  </p>
                                </div>
                                <button
                                  onClick={() =>
                                    handleDeleteReply(reply.CommentID)
                                  }
                                  className="text-[#8B4513] hover:text-red-500"
                                >
                                  <TrashIcon className="w-3.5 h-3.5" />
                                </button>
                              </div>
                              <p className="text-sm text-gray-600 mt-1">
                                {reply.CommentText}
                              </p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <p className="text-sm text-gray-600">No comments available.</p>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Signature Dialog */}
      <SignatureDialog
        showDialog={showSignatureDialog}
        setShowDialog={setShowSignatureDialog}
        onSaveSignature={handleSaveSignature}
      />

      <AddApprovalPopup
        isOpen={isPopupOpen}
        onClose={() => {
          setIsPopupOpen(false);
          fetchApprovals();
        }}
        documentId={documentId}
      />

      {showCommentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-[600px] max-w-[90%]">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Add Comment</h2>
              <button
                onClick={() => setShowCommentModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <span className="sr-only">Close</span>
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <textarea
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              className="w-full h-32 p-3 border rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your comment here..."
            />
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowCommentModal(false)}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmitComment}
                disabled={isSubmittingComment}
                className={`px-4 py-2 bg-[#8B4513] text-white rounded hover:bg-[#8B4513] flex items-center ${
                  isSubmittingComment ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                {isSubmittingComment ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Submitting...
                  </>
                ) : (
                  "Submit Comment"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentsDetails;
